import { useCallback, useTransition } from "react";

// Basically the same as <ConfirmationDialogButtons /> that
// you get if you use <ModalDialog buttons="confirm" ...,
// except:
// - I separate confirm() and cancel() props.
// - When confirm is running, both buttons are disabled
import { Button, DestructiveButton } from "@skilitics/designer-ui-components";

export interface ActionButtonsProps {
  confirmLabel: string;
  confirmDisabled?: boolean;
  confirm: () => Promise<void>;
  cancelLabel: string;
  close: () => void;
  autoFocus?: boolean;
}

export const PendingButtons = ({
  confirmLabel,
  confirmDisabled,
  confirm,
  cancelLabel,
  close,
  autoFocus = true,
}: ActionButtonsProps) => {
  const [pending, action] = useTransition();

  const confirmHandler = useCallback(() => {
    action(async () => {
      await confirm();
      close();
    });
  }, [confirm, close]);

  // Like ConfirmationDialogButtons, force focus-visible on the cancel button.
  // There's probably a better way in MUI to force the ripple styling to apply
  // on :focus not just :focus-visible?

  return (
    <>
      <Button
        action={(buttonActions) => {
          if (autoFocus) {
            buttonActions?.focusVisible();
          }
        }}
        autoFocus={autoFocus}
        color="inherit"
        disabled={pending}
        onClick={close}
        data-test="cancel-button"
      >
        {cancelLabel}
      </Button>
      <DestructiveButton disabled={pending || confirmDisabled} onClick={confirmHandler} data-test="confirm-button">
        {confirmLabel}
      </DestructiveButton>
    </>
  );
};
